// extracted by mini-css-extract-plugin
export default {"no-more-results-wrapper":"no-more-results-wrapper--mp-pa4Xd","noMoreResultsWrapper":"no-more-results-wrapper--mp-pa4Xd","icon":"icon--mp-llJmA"};